module.exports = __webpack_public_path__ + "img/md-build.b360dc24.svg";